export default __webpack_public_path__ + "static/swash-5-2f86b238d963cebc520086f4018a14a7.png";